// extracted by mini-css-extract-plugin
export default {"formContainer":"replayFormComponent_formContainer__OsNVG"};